import React, { useEffect, useMemo, useState } from 'react'
import Table from '../../../../../components/Table'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { CompayPaymentContractReport } from '../../models/models'
import { ContractReportApi } from '../../services/compayPaymentApi'
import Swal from 'sweetalert2'
import { exportToXLSX } from '../../../../../base/utils/dataHelper'

function ShoppingCreditContractReport(props: BaseComponentWithContextProps) {
  const [contractReports, setContractReports] = useState<CompayPaymentContractReport[]>([])

  useEffect(() => {
    loadContractReports()
  }, [])

  const loadContractReports = async () => {
    try {
      props.showLoading()
      const contractReportApi = new ContractReportApi({})
      const data = await contractReportApi.getContractReport()
      setContractReports(data)
    } catch (err: any) {
      console.log('Fetch Contract Report Error:', err)
      Swal.fire({
        icon: 'error',
        title: 'Hata',
        text: err.description || 'Kontrat raporu yüklenirken bir hata oluştu.',
      })
    } finally {
      props.hideLoading()
    }
  }

  const excelButton = async () => {
    try {
      if (contractReports && contractReports.length > 0) {
        const excelData: any[] = contractReports.map((report, index) => {
          const approvedDate = report.ApprovedDate
            ? new Date(report.ApprovedDate)
            : null
          const approvedDateFormatted = approvedDate
            ? approvedDate.toLocaleDateString('tr-TR') +
            ' ' +
            approvedDate.toLocaleTimeString('tr-TR')
            : '-'
          return {
            Sıra: index + 1,
            'Satıcı SAP Kodu': report.DealerSapCode,
            'Satıcı Adı': report.DealerName,
            'Onay Tarihi': approvedDateFormatted,
            'Dosya URL': report.FileUrl || '-',
          }
        })
        exportToXLSX(excelData, 'Kontrat Raporu')
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description || 'Hata',
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'Id',
      },
      {
        Header: 'Satıcı SAP Kodu',
        accessor: 'DealerSapCode',
      },
      {
        Header: 'Satıcı Adı',
        accessor: 'DealerName',
      },
      {
        Header: 'Onay Tarihi',
        accessor: 'ApprovedDate',
      },
      {
        Header: 'Dosya',
        accessor: 'FileUrl',
      },
    ],
    []
  )

  const data = useMemo(
    () =>
      contractReports?.map((report, index) => {
        const approvedDate = report.ApprovedDate
          ? new Date(report.ApprovedDate)
          : null
        const approvedDateFormatted = approvedDate
          ? approvedDate.toLocaleDateString('tr-TR') +
          ' ' +
          approvedDate.toLocaleTimeString('tr-TR')
          : '-'
        return {
          Id: index + 1,
          DealerSapCode: report.DealerSapCode,
          DealerName: report.DealerName,
          ApprovedDate: approvedDateFormatted,
          FileUrl: report.FileUrl ? (
            <a href={report.FileUrl} target="_blank" rel="noopener noreferrer" title="Dosyayı Aç">
              <i className="fas fa-download" style={{ color: '#0066cc', cursor: 'pointer', fontSize: '16px' }}></i>
            </a>
          ) : (
            '-'
          ),
        }
      }),
    [contractReports]
  )

  return (
    <div className="container">
      <div className="content col-lg-12 m-auto">
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between">
            <span className="h4">Alışveriş Kredisi Sözleşme Raporu</span>
            <button
              type="button"
              style={{
                border: '1px solid #2e7d32',
                borderRadius: 0,
                width: '29px',
                height: '29px',
                backgroundColor: 'white',
              }}
              onClick={excelButton}
              className="btn text-capitalize background-white-important d-flex align-items-center"
              title="Excele Aktarı"
            >
              <i
                className="fas fa-file-excel"
                style={{
                  marginLeft: '-6px',
                  fontSize: '18px',
                  color: '#2e7d32',
                }}
              ></i>
            </button>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-lg-12">
                <Table
                  columns={columns}
                  data={data}
                  headerName="Kontrat Raporu"
                  columnCount={5}
                  textAlign={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(ShoppingCreditContractReport)
